/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

/**
 * Script that handles toggling accordions
 */

const Accordion = {
  cfg: {
    allToggles: document.querySelectorAll('.s-accordion__item-toggle'),
    getToggles: guid =>
      document.querySelectorAll(`.s-accordion__item-toggle[data-accordion="${guid}"]`),
    getItem: (guid, index) =>
      document.querySelector(`.s-accordion__item[data-accordion="${guid}"][data-index="${index}"]`)
  },

  /**
   * Initialize.
   */
  init() {
    this.cfg.allToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        const guid = event.target.getAttribute('data-accordion');
        const index = event.target.getAttribute('data-index');

        // Set current attribute on toggle
        this.cfg.getItem(guid, index).toggleAttribute('data-expanded');
      });
    });
  }
};

export default Accordion;
